import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade, Zoom, FreeMode } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

function homeBannerSection() {
    var homeBannerSwiper = new Swiper(".home-banner__swiper", {
        modules: [ Pagination, EffectFade, Autoplay ],
        allowTouchMove: true,
        speed: 1200,
        effect: "fade",
        autoplay: {
            delay: 5400,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".home-banner__pagination",
            clickable: true
        },
        breakpoints: {
            1025: {
                allowTouchMove: false,
            },
        },
    });

    // scroll more
    const scrollMore = document.querySelector('.home-banner__more');
    const homeBanner = document.querySelector('.home-banner');
    const nextHomeBanner = homeBanner.nextElementSibling;    
    scrollMore.addEventListener('click', () => {
        gsap.to(window, { 
            ease: "Power4.easeInOut",
            duration: 0.4,
            scrollTo: { y: nextHomeBanner, offsetY: 0 }
        });
    })
}

function purposeSection() {
    const purposeLeft = document.querySelector('.purpose__left');
    const purposeDescription = document.querySelector('.purpose__col-description');
    const purposeButton = document.querySelector('.purpose__button');

    if (window.innerWidth < 992) {
        purposeDescription.append(purposeButton);
    } else {
        purposeLeft.append(purposeButton);
    }
}

function speciesSection() {
    var speciesSwiper = new Swiper(".species__swiper", {
        modules: [ FreeMode ],
        slidesPerView: 1.2,
        spaceBetween: 16,
        freeMode: true
    });
}

function latestNewsSection() {
    // button placement on responsive
    const latestNewsButtonWrapper = document.querySelector('.latest-news__button-wrapper-mobile');
    const latestNewsHeader = document.querySelector('.latest-news__header');
    const latestNewsButton = document.querySelector('.latest-news__button');
    if (window.innerWidth < 992) {
        latestNewsButtonWrapper.append(latestNewsButton);
    } else {
        latestNewsHeader.append(latestNewsButton);
    }

    // latest news match height
    const newsTitle = document.querySelectorAll('.news-card__title');
    matchHeight(newsTitle);
}

function donationSection() {
    const donationSection = document.querySelector(".donation");
    const donationWrapper = document.querySelector(".donation__wrapper");   

    let mm = gsap.matchMedia()
    mm.add("(min-width: 1025px)", () => {
        ScrollTrigger.create({
            trigger: donationSection,
            pin: donationWrapper,
            start: "top+=5% top",
            end: "bottom-=13% bottom",
            // markers: true
        });
    })
}

function instagramSection() {
    // button placement on responsive
    const instagramButtonWrapper = document.querySelector('.instagram__button-wrapper-mobile');
    const instagramHeader = document.querySelector('.instagram__header');
    const instagramButton = document.querySelector('.instagram__button');
    if (window.innerWidth < 576) {
        instagramButtonWrapper.append(instagramButton);
    } else {
        instagramHeader.append(instagramButton);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    homeBannerSection();
    purposeSection();
    speciesSection();
    latestNewsSection();
    donationSection();
    instagramSection();
})

window.addEventListener('resize', () => {
    purposeSection();
    latestNewsSection();
    instagramSection();
})